import { DetailsList } from "react-migration/components/DetailsList";
import { PlanningApplication } from "react-migration/domains/planning/types";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { PLANNING_TEXT_COLOR_MAP, PlanningColor, getAppealColor } from "../../utils/colors";
import { protectedDateFormatter } from "../../utils/protectedDateFormatter";

export const AppealDetails = ({ planningApplication }: { planningApplication: PlanningApplication }) => {
  const { t } = useTranslation();

  return (
    <section className="border-t border-neutral-300">
      <div className="px-2 py-3 space-2 space-y-2">
        <h1 className="text-sm flex text-neutral-800 mb-1">
          {t("planning.planning_application_list.planning_application_list.planning_appeal_title", {
            caseNumber: planningApplication.appeal_case_number,
          })}
        </h1>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.type">
          {planningApplication.appeal_type_of_appeal ? planningApplication.appeal_type_of_appeal : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.type_reason">
          {planningApplication.appeal_type_reason ? planningApplication.appeal_type_reason : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.address">
          {planningApplication.appeal_type_reason ? planningApplication.appeal_type_reason : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.decision">
          <span
            className={
              planningApplication.appeal_decision && planningApplication.appeal_decision_date
                ? PLANNING_TEXT_COLOR_MAP[getAppealColor(planningApplication.appeal_decision) || PlanningColor.DEFAULT]
                : undefined
            }
          >
            {planningApplication.appeal_decision && planningApplication.appeal_decision_date
              ? `${planningApplication.appeal_decision} (${
                  planningApplication.appeal_decision_date &&
                  protectedDateFormatter(planningApplication.appeal_decision_date)
                })`
              : "N/A"}
          </span>
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.date_received">
          {planningApplication.appeal_received_date
            ? protectedDateFormatter(planningApplication.appeal_received_date)
            : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.development_type">
          {planningApplication.appeal_development_type ? planningApplication.appeal_development_type : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.inspector">
          {planningApplication.appeal_inspector_name ? planningApplication.appeal_inspector_name : "N/A"}
        </DetailsList.Item>
        <DetailsList.Item label="planning.planning_application_list.planning_application_list.planning_appeal_details.appellant">
          {planningApplication.appeal_appellant ? planningApplication.appeal_appellant : "N/A"}
        </DetailsList.Item>
        <div className="flex space-x-2 gap-2 mt-5 text-text-base-tertiary">
          {planningApplication.appeal_inspector_name && (
            <div className="text-xs font-regular">
              <span>{t("planning.planning_application_list.planning_application_detail_view.source")}</span>
              <span className="font-semibold">
                {t("planning.planning_application_list.planning_application_detail_view.planning_inspectorate")}
              </span>
            </div>
          )}
          {planningApplication.appeal_updated_at && (
            <div className="text-xs font-regular text-neutral-500">
              {t("planning.planning_application_list.planning_application_detail_view.record_last_checked")}
              <span className="font-semibold detail">
                {protectedDateFormatter(planningApplication.appeal_updated_at)}
              </span>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
